import { MenuNavigationItemTypeDesktopGroup } from './types';

export const checkIfContainsItem = (item: MenuNavigationItemTypeDesktopGroup, activeId: string) : boolean => {
    if(item.id == activeId)
        return true;
    if(item.items.findIndex(x => x.type == 'item' && x.to == activeId) >= 0)
        return true;
    return item.items.some(x => x.type == 'desktopgroup' && checkIfContainsItem(x, activeId));
}